// main
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { Row, Col } from 'antd';

import WebbDividerMedium from "../webx/webb-divider-md";
import ContentCardMedium from '../webx/content-card-md';


const list = require('../../data/data-articles.json').data

export default function MainArticlesModule () {
  
  const [data, setData] = useState(list);

  return (
  <>
    <div className=''>
      <h2 className='m-0'>Articles</h2>
      <h3 className='m-0 text-color-tone'>PowerUp Your NFT Knowledge</h3>
    </div>

    <WebbDividerMedium/>
    <div className='m-0 p-0'>
      <Row className="" gutter={{ xs: 6, sm: 6, md: 6, lg: 6 }}>

      {data && data.map((item, i) => (
        <Col className="m-0 p-0" xs={{span:24}} md={{span:8}} key={i}>
          <ContentCardMedium data={item}/>
        </Col>
      ))}
      </Row>
    </div>

  </>
  )
}